class EventsEngineClass {
    _listeners = {}

    init = () => {
        this._listeners = {}
    }

    subscribe = <T>(event: string, id: string, callback: (arg?: T) => void) => {
        if (!this._listeners[event])
            this._listeners[event] = {}

        this._listeners[event][id] = callback

        return () => this.unsubscribe(event, id)
    }

    publish = (event: string, arg?: any) => {
        if (!this._listeners[event]) return

        Object.keys(this._listeners[event])
            .forEach(id => this._listeners[event][id](arg))
    }

    unsubscribe = (event: string, id: string) => {
        if (!this._listeners[event]) return
        delete this._listeners[event][id]

        if (Object.keys(this._listeners[event]).length === 0)
            delete this._listeners[event]
    }
}

const EventsEngine = new EventsEngineClass()
export default EventsEngine
